import { PpssPerformanceComponent } from '@products/fund-listing/ppss/ppss-performance/ppss-performance.component';
import { AgGridHelperService } from '@products/fund-listing/services/ag-grid-helper.service';
import { TranslateService } from '@shared/translate/translate.service';
import { PPSSState } from '@types';
import { ColGroupDef } from '@ag-grid-community/core';

/**
 * Return performance column definitions for US 529 Portfolios.
 * @param ppssTab ppss tab component
 * @param state ppss service state
 * @param agGridHelperService ag grid helper service instance
 */
export function getPerformanceColumnDefsForUS_529(
  ppssTab: PpssPerformanceComponent,
  state: PPSSState,
  agGridHelperService: AgGridHelperService,
  translateService: TranslateService
): ColGroupDef[] {
  const colGroupDefs: ColGroupDef[] = [
    {
      groupId: 'FUND',
      headerGroupComponent: 'calcTypeGroupHeaderComponent',
      headerGroupComponentParams: {
        parentComponent: ppssTab,
        configurationName: ppssTab.productType,
        calcType: ppssTab.calcType,
      },
      children: [
        agGridHelperService.getFavFundColDef(ppssTab),
        agGridHelperService.getFundNameColDef(
          false,
          false,
          null,
          ppssTab.productType
        ),
        agGridHelperService.getShareClassNameColDef(),
      ],
    },
    {
      groupId: 'NAV',
      headerGroupComponent: 'dateGroupHeaderComponent',
      headerGroupComponentParams: {
        asOfDateText: () => ppssTab.navAsOfDate,
      },
      children: [
        agGridHelperService.getNavValueColDef(),
        agGridHelperService.getNavChangeValueColDef(),
        agGridHelperService.getNavYTDReturnColDef({
          headerName: translateService.instant(
            'products.ytd-total-returns-nav'
          ),
          width: 80,
        }),
      ],
    },
    {
      groupId: 'PERFORMANCE',
      headerGroupComponent: 'performanceGroupHeaderComponent',
      headerGroupComponentParams: {
        perfTable: ppssTab,
      },
      children: [
        agGridHelperService.getAvgAnnualMonthly1YrColDef(
          state.config.suppressDetails,
          {
            width: 90,
          }
        ),
        agGridHelperService.getAvgAnnualMonthly3YrColDef({
          width: 90,
        }),
        agGridHelperService.getAvgAnnualMonthly5YrColDef({
          width: 90,
        }),
        agGridHelperService.getAvgAnnualMonthly10YrColDef({
          width: 90,
        }),
        agGridHelperService.getAvgAnnualMonthlyInceptionColDef(
          state.config.suppressDetails
        ),
        agGridHelperService.getAvgAnnualQuarterly1YrColDef(
          state.config.suppressDetails,
          {
            width: 90,
          }
        ),
        agGridHelperService.getAvgAnnualQuarterly3YrColDef({
          width: 90,
        }),
        agGridHelperService.getAvgAnnualQuarterly5YrColDef({
          width: 90,
        }),
        agGridHelperService.getAvgAnnualQuarterly10YrColDef({
          width: 90,
        }),
        agGridHelperService.getAvgAnnualQuarterlyInceptionColDef(
          state.config.suppressDetails
        ),
        agGridHelperService.getTotalAnnualOperatingExpensesColDef({
          width: 115,
        }),
      ],
    },
  ];
  ppssTab.calcTypeParams = colGroupDefs.find(
    (colGroupDef: ColGroupDef): boolean => colGroupDef.groupId === 'FUND'
  ).headerGroupComponentParams;
  ppssTab.performanceParams = colGroupDefs.find(
    (colGroupDef: ColGroupDef): boolean => colGroupDef.groupId === 'PERFORMANCE'
  ).headerGroupComponentParams;
  return colGroupDefs;
}
